/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from 'moment';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dialog, DialogContent } from '@material-ui/core';
import {
  MinDate,
  MaxDate,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  closeTab,
  getCommonDropdownList,
  handleScrollToEvent,
  removeDollarForNumberFiled,
  removeCommaForNumberFiled,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as ErrorMessage from './errorMessage';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import {
  checkForValidDateString,
  setDateFormatter,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getSaveCheckValuesResults,
  deleteCheckValuesResults,
  maintainCheckReqAction,
  maintainCheckFormErrorAction,
  maintainCheckErrorMessageAction,
  dispatchSaveCheckValues,
  getExistingCorrLinkIds,
  getSearchCheckResults,
} from '../store/actions';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  checkActionAccessByRole,
  checkReadOnlyAccessFc,
  PaperComponent,
} from '../../../../SharedModules/utilities/utilities';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';

/**
 * Maintain Chech  Component helps user to correct the check based on different criteria such as Check log, check Number, CCN etc if there is any mistake made.
 * @Date 10-OCT-2022
 * @author Nazia Rizwan
 */

const MaintainCheck = (props) => {
  const [values, setValues] = React.useState({
    checkLogNum: '',
    checkNum: '',
    batchNum: '',
    disputeResolution: '-1',
    usedDrugRebate: 0,
    cnnNum: '',
    checkPayee: '-1',
    checkAmt: '',
    totalAmt: '',
    fullyAllocated: 0,
    alterCheckAmt: '',
    checkIssuer: '',
    informationTxt: '',
    paymentType: '-1',
    invoiceReconcilication: '-1',
    checkDate: null,
    receivedDate: null,
    suspendedDate: null,
    batchDate: null,
    postDate: null,
    corrLinkId: '',
  });
  const [hasChanges, setHasChanges] = React.useState(false);
  const [formErrors, setFormsError] = React.useState({
    checkDate: false,
    receivedDate: false,
    suspendedDate: false,
    batchDate: false,
    postDate: false,
    checkIssuer: false,
    checkPayee: false,
    checkEmptyDate: false,
    alterCheckAmt: false,
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const maintainCheckRequest = useSelector(
    (state) => state?.sharedState?.CheckReducer?.maintainCheckRequestData
  );
  const maintainCheckFormErrorRequest = useSelector(
    (state) => state?.sharedState?.CheckReducer?.maintainCheckFormErrorData
  );
  const maintainCheckErrorMsgRequest = useSelector(
    (state) => state?.sharedState?.CheckReducer?.maintainCheckErrorMessage
  );

  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const clickOnMaintainCheckVal = useSelector((state) => {
    return state.sharedState.displayCheck?.clickOnMaintainCheckOption;
  });
  const getSaveCheckValues = (value) =>
    dispatch(getSaveCheckValuesResults(value));

  let getSaveCheckState = useSelector((state) => {
    return state.sharedState.CheckReducer.saveCheckValues;
  });
  const getDeleteCheckValues = (value) =>
    dispatch(deleteCheckValuesResults(value));
  const getDeleteCheckState = useSelector((state) => {
    return state.sharedState.CheckReducer.deleteCheckValues;
  });
  const userRoles = useSelector((state) => {
    return state.sharedState.CheckReducer?.loginUseRole;
  });
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.CheckLogReducer.generalSystemParameter
      ?.paramGeneralVO;
  });
  const { kcRoles, loginStateStoreObj } = useSelector(
    (state) => state.sharedState.SharedReducer
  );
  const checkReadOnlyAccess = checkReadOnlyAccessFc(
    'Maintain',
    'Check',
    '/check',
    loginStateStoreObj
  );
  const [commonDropdownList, setCommonDropdownList] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [openFullyAllocatedConfirm, setOpenFullyAllocatedConfirm] =
    React.useState(false);
  const [spinnerLoader, setSpinnerLoader] = React.useState(false);
  const [alterDialog, setAlterDialog] = React.useState(false);
  const [saveDialog, setSaveDailog] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState([]);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [disableCCN, setDisableCCN] = React.useState(true);
  const [applicableUser, setApplicableUser] = React.useState(false);
  const [disableBatch, setDisableBatch] = React.useState(true);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [comments, setComments] = React.useState(false);
  const [deleteLog, setDeleteLog] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState({});
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  // const logInUserID = localStorage.getItem('logInUser');
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnableByRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(
      process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
      kcRoles
    )
  );
  const hasRole = (role) =>
    kcRoles?.userPrivileges?.some((r) => r === role) || false;

  // Normal User may edit check detail fields; other restricted roles stay locked
  const isFieldsDisabled =
    checkReadOnlyAccess ||
    (isEnableByRole === false && !hasRole('Normal User'));

  const canDeclareCheckAllocated =
    (hasRole('Normal User') ||
      hasRole('Developer') ||
      hasRole('System Administrator')) &&
    !hasRole('State Employee') &&
    !hasRole('INQUIRY State Employee');

  const disableOtherButtons =
    hasRole('Normal User') ||
    hasRole('State Employee') ||
    hasRole('INQUIRY State Employee');

  const canNormalUserSave = hasRole('Normal User') && hasChanges;

  const [readOnly, setReadOnly] = React.useState(
    !checkActionAccessByRole(process.env.REACT_APP_NORMAL_ONLY_ROLE, kcRoles)
  );
  const [check, setCheck] = React.useState(false);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  React.useEffect(() => {
    if (generalSystemParameterDetails) {
      const usesBatch =
        generalSystemParameterDetails?.[0]?.checkLogUsesBatchInd;
      if (usesBatch === 0) {
        setCheck(true);
      } else {
        setCheck(false);
      }
    }
  }, [generalSystemParameterDetails]);
  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  const handleCloseFullyAllocatedConfirm = () => {
    setOpenFullyAllocatedConfirm(false);
  };

  const handleConfirmFullyAllocated = () => {
    setOpenFullyAllocatedConfirm(false);
    setValues((prev) => ({ ...prev, fullyAllocated: 1 }));
    setHasChanges(true);
    dispatch(
      maintainCheckReqAction({
        ...maintainCheckRequest,
        fullyAllocated: 1,
      })
    );
  };

  const [showViewHistory, setShowViewHistory] = React.useState(false);
  // Service call for View History button click
  const getShowViewHistoryPlan = () => {
    setShowViewHistory(true);
    setKeyValue({ CHECK_LOG_NUM: values.checkLogNum });
  };
  const getCommentsService = () => {
    setShowComments(true);
  };

  // on Load on the page,this React.useEffect will be called
  const [corrLinkId, setCorrLinkId] = React.useState();

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (maintainCheckRequest && Object.keys(maintainCheckRequest).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/maintain-check') {
            item.isFormDirty = true;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    } else {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/maintain-check') {
            item.isFormDirty = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [maintainCheckRequest]);
  React.useEffect(() => {
    handleScrollToEvent();
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
          kcRoles
        )
      );
      setReadOnly(
        !checkActionAccessByRole(
          process.env.REACT_APP_NORMAL_ONLY_ROLE,
          kcRoles
        )
      );
    }
  }, [kcRoles]);
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      maintainCheckErrorMsgRequest &&
      Object.keys(maintainCheckErrorMsgRequest).length > 0
    ) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/maintain-check') {
            item.isFormError = true;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    } else {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/maintain-check') {
            item.isFormError = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [maintainCheckErrorMsgRequest]);
  // On clicking on Save, this function will perform all the validations
  // if no error, then only SaveCheck service call will be made.
  const onValidation = (name = '', error = false) => {
    const errorDisplay = [];
    if (formErrors.checkDate) {
      errorDisplay.push(ErrorMessage.CHECK_INVALID_DATE);
    }
    // if (formErrors.checkEmptyDate) {
    //   errorDisplay.push(ErrorMessage.CHECK_DATE_VALIDATION);
    // }
    if (formErrors.receivedDate) {
      errorDisplay.push(ErrorMessage.REC_INVALID_DATE);
    }
    if (formErrors.suspendedDate) {
      errorDisplay.push(ErrorMessage.SUS_INVALID_DATE);
    }
    if (formErrors.batchDate) {
      errorDisplay.push(ErrorMessage.BATCH_INVALID_DATE);
    }
    if (formErrors.postDate) {
      errorDisplay.push(ErrorMessage.POST_INVALID_DATE);
    }
    if (formErrors.checkIssuer) {
      errorDisplay.push(ErrorMessage.CHECK_ISSUER_VALIDATION);
    }
    if (formErrors.checkPayee) {
      errorDisplay.push(ErrorMessage.CHECK_PAYEE_VALIDATION);
    }
    setErrorMessages(errorDisplay);
    dispatch(maintainCheckErrorMessageAction(errorDisplay));
    if (errorDisplay.length > 0) {
      return false;
    }
    return true;
  };
  // FOrmatting the data for passing it to save check service call
  const masterDataSave = () => {
    const totalAmtType = typeof values.totalAmt;
    const checkAmtType = typeof values.checkAmt;
    const totalAmt =
      totalAmtType === 'string'
        ? values.totalAmt?.includes('$')
          ? values.totalAmt && values?.totalAmt?.split('$ ')[1]
          : values.totalAmt
        : values.totalAmt;
    const checkAmtVal =
      checkAmtType === 'string'
        ? values.checkAmt?.includes('$')
          ? values.checkAmt && values.checkAmt?.split('$ ')[1]
          : values.checkAmt
        : values.checkAmt;

    let pass = false;
    const newData = {
      checkLogNum: values.checkLogNum,
      lastUpdateUserId: logInUser,
      totAllocatedAmt:
        totalAmt && totalAmt != 'null'
          ? parseFloat(totalAmt?.toString().replace(',', '').trim())
          : null,
      checkPayeeCd: values.checkPayee != -1 ? values.checkPayee : null,
      checkAmt:
        checkAmtVal && checkAmtVal != 'null'
          ? parseFloat(checkAmtVal?.toString().replace(',', '').trim())
          : null,
      allocationCompleteInd: values.fullyAllocated ? values.fullyAllocated : 0,
      checkDt: values.checkDate ? setDateFormatter(values.checkDate) : null,
      suspendedDt: values.suspendedDate
        ? setDateFormatter(values.suspendedDate)
        : null,

      batchDt: values.batchDate ? setDateFormatter(values.batchDate) : null,
      batchNum: values.batchNum,
      checkNum: values.checkNum,
      postmarkedDt: values.postDate ? setDateFormatter(values.postDate) : null,
      receivedDt: values.receivedDate
        ? setDateFormatter(values.receivedDate)
        : null,
      checkIssuer: values.checkIssuer,
      invRecFormatCd:
        values.invoiceReconcilication != -1
          ? values.invoiceReconcilication
          : null,
      disputeResolutionCd:
        values.disputeResolution != -1 ? values.disputeResolution : null,
      notDrugRebateInd: values.usedDrugRebate,
      corrLinkId: values.corrLinkId ? parseFloat(values.corrLinkId) : null,
      checkIdentifier: values.cnnNum ? values.cnnNum : null,
      checkInfo: values.informationTxt ? values.informationTxt : null,
      paymentMediaTypeCd: values.paymentType != -1 ? values.paymentType : null,
    };
    const err = _.cloneDeep(formErrors);
    const errorDisplay = [];
    // if (!newData.checkDt) {
    //   err.checkEmptyDate = true;
    //   errorDisplay.push(ErrorMessage.CHECK_DATE_VALIDATION);
    // }
    if (!newData.checkPayeeCd) {
      err.checkPayee = true;
      errorDisplay.push(ErrorMessage.CHECK_PAYEE_VALIDATION);
    }
    if (!newData.checkIssuer) {
      err.checkIssuer = true;
      errorDisplay.push(ErrorMessage.CHECK_ISSUER_VALIDATION);
    }
    if (
      // err.checkEmptyDate ||
      err.checkPayee ||
      err.checkIssuer
    ) {
      pass = false;
    } else {
      pass = true;
    }
    setSaveDailog(false);
    if (pass) {
      getSaveCheckValues(newData);
    } else {
      setFormsError(err);
      setErrorMessages(errorDisplay);
      dispatch(maintainCheckErrorMessageAction(errorDisplay));
    }
  };
  // On Save button click
  const onSave = (value) => {
    setClickOncloseTabBtn(value);
    if (onValidation()) {
      setSaveDailog(value);
      if (!value) masterDataSave();
    }
  };
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/maintain-check' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/maintain-check' && item.isFormSave) {
          item.isFormSave = false;
          onSave(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  // Setting the dropdown values
  React.useEffect(() => {
    const checkLogByCCN = JSON.parse(localStorage.getItem('checkLogByCCN'));
    const checkLogBatchNum = JSON.parse(
      localStorage.getItem('checkLogBatchNum')
    );
    if (
      userRoles?.filter((x) => {
        return x === 'System Administrator';
      })?.length > 0
    ) {
      setApplicableUser(true);
    } else {
      setApplicableUser(false);
    }
    if (checkLogByCCN) {
      setDisableCCN(false);
    } else if (checkLogByCCN == false || checkLogByCCN == null) {
      setDisableCCN(true);
    }
    if (checkLogBatchNum) {
      setDisableBatch(false);
    } else if (checkLogBatchNum == false || checkLogBatchNum == null) {
      setDisableBatch(true);
    }
    setSuccessMessage([]);
  }, []);

  const closeAlterDialog = () => {
    setValues({ ...values, alterCheckAmt: '' });
    setFormsError({ ...formErrors, alterCheckAmt: false });
    setAlterDialog(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // On changing the Field values other than dates, this function will be called and set the values accordingly
  const handleOnChangeEvent = (e, name) => {
    const regexNumber = /^-?\d+(\.\d{0,2})?$/;
    if (
      name === 'alterCheckAmt' &&
      (regexNumber.test(e.target.value) ||
        e.target.value.length > 15 ||
        e.target.value === '')
    ) {
      setValues({ ...values, [name]: e.target.value });
      const data = {
        ...maintainCheckRequest,
        [name]: e.target.value,
      };
      dispatch(maintainCheckReqAction(data));
    } else if (name !== 'alterCheckAmt') {
      setValues({ ...values, [name]: e.target.value });
      const data = {
        ...maintainCheckRequest,
        [name]: e.target.value,
      };
      dispatch(maintainCheckReqAction(data));
    }
    const formErr = {
      ...maintainCheckFormErrorRequest,
      [name]: false,
    };
    dispatch(maintainCheckFormErrorAction(formErr));
    setFormsError({ ...formErrors, [name]: false });
    setHasChanges(true);
    setSuccessMessage([]);
    if (errorMessages.length > 0) {
      const errorMsg = [];
      const error = errorMessages?.map((item) => {
        if (
          item != ErrorMessage.FULLY_ALLOCATED &&
          item != ErrorMessage.PARTIALLY_ALLOCATED &&
          item != ErrorMessage.DELETE_MAINTAIN &&
          item != ErrorMessage.API_FAILED
        ) {
          return errorMsg.push(item);
        }
      });
      setErrorMessages(errorMsg);
    }
  };
  const handleBlurEvent = (e, name) => {
    setSuccessMessage([]);
    setHasChanges(true);
    if (name === 'checkIssuer' && e.target.value != '') {
      setValues({ ...values, [name]: e.target.value });
    } else if (name == 'checkPayee' && e.target.value == -1) {
      formErrors[name] = true;
      setFormsError({ ...formErrors, [name]: true });
    } else if (name == 'checkPayee' && e.target.value != -1) {
      setFormsError({ ...formErrors, [name]: false });
    } else if (name === 'checkIssuer' && e.target.value == '') {
      formErrors[name] = true;
      setFormsError({ ...formErrors, [name]: formErrors[name] });
    }
    const data = {
      ...maintainCheckRequest,
      [name]: e.target.value,
    };
    dispatch(maintainCheckReqAction(data));
    const formErr = {
      ...maintainCheckFormErrorRequest,
      [name]: formErrors[name],
    };
    dispatch(maintainCheckFormErrorAction(formErr));
    onValidation(name, formErrors[name]);
  };
  const handleAlterAmtBlurEvent = (e, name) => {
    if (e.target.value == '.') {
      setFormsError({ ...formErrors, [name]: true });
    } else setFormsError({ ...formErrors, [name]: false });
  };
  // On changing the Dates, this function will be called and set the values accordingly
  const handleChangeDate = (event, name) => {
    // var regex = /[0-9]/g;
    const dateFormat = event;
    setHasChanges(true);
    setFormsError({ ...formErrors, [name]: false });
    if (formErrors.checkEmptyDate && name == 'checkDate') {
      setFormsError({ ...formErrors, checkEmptyDate: false });
      const formErr = {
        ...maintainCheckFormErrorRequest,
        checkEmptyDate: false,
      };
      dispatch(maintainCheckFormErrorAction(formErr));
    }
    setValues({ ...values, [name]: dateFormat });
    setSuccessMessage([]);
    if (errorMessages.length > 0) {
      const errorMsg = [];
      const error = errorMessages.map((item) => {
        if (
          item != ErrorMessage.FULLY_ALLOCATED &&
          item != ErrorMessage.PARTIALLY_ALLOCATED &&
          item != ErrorMessage.DELETE_MAINTAIN &&
          item != ErrorMessage.API_FAILED
        ) {
          return errorMsg.push(item);
        }
      });
      setErrorMessages(errorMsg);
    }
    const data = {
      ...maintainCheckRequest,
      [name]: dateFormat,
    };
    dispatch(maintainCheckReqAction(data));
  };

  // on Declare Check allocated button click
  const declareCheckAllocated = () => {
    setSuccessMessage([]);
    if (values.fullyAllocated) {
      let hasError = false;
      if (errorMessages.length > 0) {
        const error = errorMessages.map((item) => {
          if (item == ErrorMessage.FULLY_ALLOCATED) {
            hasError = true;
            return hasError;
          }
        });
      }
      if (!hasError) setErrorMessages([ErrorMessage.FULLY_ALLOCATED]);
    } else if (values.checkAmt === values.totalAmt) {
      setOpenFullyAllocatedConfirm(true);
    } else if (
      !formErrors.checkDate &&
      !formErrors.postDate &&
      !formErrors.receivedDate &&
      !formErrors.batchDate &&
      !formErrors.suspendedDate &&
      !formErrors.checkEmptyDate
    )
      setOpen(true);
  };
  const updateSuspendedDate = () => {
    const currentDate = new Date();
    const dateFormat = moment(currentDate).format('MM/DD/YYYY');
    setValues({ ...values, suspendedDate: dateFormat, fullyAllocated: 1 });
    const data = {
      ...maintainCheckRequest,
      suspendedDate: dateFormat,
      fullyAllocated: 1,
    };
    setHasChanges(true);
    dispatch(maintainCheckReqAction(data));
    setOpen(false);
  };
  const onClickAlterCheckAmt = () => {
    setSuccessMessage([]);
    if (errorMessages.length > 0) {
      const errorMsg = [];
      const error = errorMessages.map((item) => {
        if (
          item != ErrorMessage.FULLY_ALLOCATED &&
          item != ErrorMessage.PARTIALLY_ALLOCATED
        ) {
          return errorMsg.push(item);
        }
      });
      setErrorMessages(errorMsg);
    }
    setAlterDialog(true);
  };

  const updateCheckAmt = () => {
    if (!formErrors?.alterCheckAmt) {
      const dollarSymbol = '$ ';
      const alterChkAmt = dollarSymbol.concat(values.alterCheckAmt);
      setValues({ ...values, checkAmt: alterChkAmt, alterCheckAmt: '' });
      const data = {
        ...maintainCheckRequest,
        checkAmt: alterChkAmt,
      };
      dispatch(maintainCheckReqAction(data));
      setHasChanges(true);
      setAlterDialog(false);
    }
  };
  const handleSaveClose = () => {
    setSaveDailog(false);
  };
  // On Bluring on the fields of the Dates, this function will be called and set the values accordingly
  // if the format is not correct, error message will be displayed
  const handleBlurDate = (event, name) => {
    const dateFromPicker = event.target.value.split('_')
      ? event.target.value.split('_')[0]
      : event.target.value;
    const regexNumber = /^[0-9/]+$/;
    if (regexNumber.test(dateFromPicker)) {
      if (dateFromPicker.length === 10 && dateFromPicker.includes('/')) {
        const splitDate = dateFromPicker.split('/');
        const splitYear = splitDate[2] >= 1991;
        const checkValidDate = checkForValidDateString(dateFromPicker);
        const finalDate = dateFromPicker;

        if (checkValidDate && splitYear) {
          setValues({
            ...values,
            [name]: finalDate,
          });
        } else {
          formErrors[name] = true;
        }
      } else if (dateFromPicker.length === 8 && dateFromPicker.includes('/')) {
        const splitDate = dateFromPicker.split('/');
        const currentYear = new Date().getFullYear();
        const getCurrentCentury = currentYear.toString().substring(0, 2);
        const formattedYear = getCurrentCentury.concat(splitDate[2]);
        const formattedDate = splitDate[0].concat(
          '/',
          splitDate[1],
          '/',
          formattedYear
        );
        setValues({
          ...values,
          [name]: formattedDate,
        });
      } else if (
        (dateFromPicker.length === 6 || dateFromPicker.length === 5) &&
        dateFromPicker.includes('/')
      ) {
        const splitDate = dateFromPicker.split('/');
        const currentYear = new Date().getFullYear();
        const getCurrentCentury = currentYear.toString().substring(0, 2);
        const formattedYear = getCurrentCentury.concat(splitDate[1]);
        const formattedDate = splitDate[0].concat(
          '/',
          '01',
          '/',
          formattedYear
        );
        setValues({
          ...values,
          [name]: formattedDate,
        });
      } else {
        formErrors[name] = true;
      }
    }
    // else if (dateFromPicker === '' && name == 'checkDate') {
    //   formErrors.checkEmptyDate = true;
    // }
    else if (dateFromPicker === '') {
      formErrors[name] = false;
    } else formErrors[name] = true;
    setFormsError({ ...formErrors, [name]: formErrors[name] });
    const data = {
      ...maintainCheckRequest,
      [name]: dateFromPicker,
    };
    dispatch(maintainCheckReqAction(data));
    const formErr = {
      ...maintainCheckFormErrorRequest,
      [name]: formErrors[name],
      // checkEmptyDate: !!(dateFromPicker === '' && name == 'checkDate'),
    };
    dispatch(maintainCheckFormErrorAction(formErr));
    if (formErrors[name]) window.scrollTo(0, 0);
    onValidation();
  };

  // Handling the response of Savecheck
  React.useEffect(() => {
    if (getSaveCheckState && getSaveCheckState.data == '001') {
      dispatch(dispatchSaveCheckValues({}));
      // dispatch(maintainCheckReqAction({}));
      if (!clickOncloseTabBtn) closeTab('/maintain-check', history, dispatch);
      setHasChanges(false);
      setSuccessMessage([ErrorMessage.SUCCESS_MAINTAIN]);
      setSaveDailog(false);
      const getValues = JSON.parse(
        window.localStorage.getItem('checkSearchValues')
      );
      const parseValues = JSON.parse(
        window.localStorage.getItem('checkSearchValues')
      );
      getValues.checkNum = values.checkNum
        ? values.checkNum
        : parseValues.checkNum;
      getValues.batchNum = values.batchNum
        ? values.batchNum
        : parseValues.batchNum;
      getValues.checkIssuer = values.checkIssuer
        ? values.checkIssuer
        : parseValues.checkIssuer;
      getValues.checkInfo = values.informationTxt
        ? values.informationTxt
        : parseValues.checkInfo;
      getValues.checkAmt = values.checkAmt
        ? values.checkAmt
        : parseValues.checkAmt;
      getValues.totAllocatedAmt = values.totalAmt
        ? values.totalAmt
        : parseValues.totAllocatedAmt;
      getValues.invRecFormatCd =
        values.invoiceReconcilication != -1
          ? values.invoiceReconcilication
          : parseValues.invRecFormatCd;
      getValues.checkPayeeCd =
        values.checkPayee != -1 ? values.checkPayee : parseValues.checkPayeeCd;
      getValues.disputeResolutionCd =
        values.disputeResolution != -1
          ? values.disputeResolution
          : parseValues.disputeResolutionCd;
      getValues.paymentMediaTypeCd =
        values.paymentType != -1
          ? values.paymentType
          : parseValues.paymentMediaTypeCd;
      getValues.batchDt = values.batchDate
        ? values.batchDate
        : parseValues.batchDt;
      getValues.checkDt = values.checkDate
        ? values.checkDate
        : parseValues.checkDt;
      getValues.receivedDt = values.receivedDate
        ? values.receivedDate
        : parseValues.receivedDt;
      getValues.postmarkedDt = values.postDate
        ? values.postDate
        : parseValues.postmarkedDt;
      getValues.suspendedDt = values.suspendedDate
        ? values.suspendedDate
        : parseValues.suspendedDt;
      getValues.allocationCompleteInd = values.fullyAllocated
        ? values.fullyAllocated
        : parseValues.allocationCompleteInd;
      getValues.usedDrugRebate = values.notDrugRebateInd
        ? values.notDrugRebateInd
        : parseValues.usedDrugRebate;
      getValues.checkIdentifier = values.cnnNum
        ? values.cnnNum
        : parseValues.checkIdentifier;
      const getSearch = JSON.parse(localStorage.getItem('initialSearchValues'));

      dispatch(getSearchCheckResults(getSearch, clickOnMaintainCheckVal));
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/maintain-check') {
            item.isFormDirty = false;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    } else if (getSaveCheckState && getSaveCheckState.error == 'API failed') {
      setErrorMessages([ErrorMessage.API_FAILED]);
      setSaveDailog(false);
    }
  }, [getSaveCheckState]);

  const onDelete = () => {
    setSuccessMessage([]);
    const totalAmt = values.totalAmt && values.totalAmt?.split('$')[1];
    if (values.fullyAllocated == 1) {
      let hasError = false;
      if (errorMessages.length > 0) {
        const error = errorMessages.map((item) => {
          if (item == ErrorMessage.PARTIALLY_ALLOCATED) {
            hasError = true;
            return hasError;
          }
        });
      }
      if (!hasError) setErrorMessages([ErrorMessage.PARTIALLY_ALLOCATED]);
    } else if (
      values.checkAmt != values.totalAmt &&
      totalAmt != 0 &&
      totalAmt != 'null'
    ) {
      let hasError = false;
      if (errorMessages.length > 0) {
        const error = errorMessages.map((item) => {
          if (item == ErrorMessage.PARTIALLY_ALLOCATED) {
            hasError = true;
            return hasError;
          }
        });
      }
      if (!hasError) setErrorMessages([ErrorMessage.PARTIALLY_ALLOCATED]);
    } else if (totalAmt == 0 && values.fullyAllocated == 0) {
      setOpenDelete(true);
    } else if (totalAmt == null && values.fullyAllocated == 0) {
      setOpenDelete(true);
    } else {
      setOpenDelete(true);
    }
  };
  const handleDeleteClose = () => {
    setOpenDelete(false);
  };
  // FOrming the request of Delete Check service call
  const masterDelete = () => {
    const newData = {
      checkLogNum: values.checkLogNum ? parseFloat(values.checkLogNum) : '',
    };
    setDeleteLog(true);
    getDeleteCheckValues(newData);
  };
  // Handling the response of Deletecheck
  React.useEffect(() => {
    if (
      getDeleteCheckState &&
      getDeleteCheckState.status == '001' &&
      deleteLog
    ) {
      //dispatch(maintainCheckReqAction({}));
      dispatch(maintainCheckFormErrorAction({}));
      dispatch(maintainCheckErrorMessageAction([]));
      setDeleteLog(false);
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      let insertCheckTab = true;
      const tabDetails = updateTabs.map((item) => {
        if (item.navTo == '/check') {
          insertCheckTab = false;
        }
        if (item.navTo == '/maintain-check') {
          updateTabs.pop(item);
        }
      });
      if (insertCheckTab) {
        updateTabs.push({
          navTo: '/check',
          value: 'Check',
        });
      }
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/check',
      });
    } else if (
      getDeleteCheckState &&
      getDeleteCheckState.error == 'API failed'
    ) {
      setErrorMessages([ErrorMessage.API_FAILED]);
      setOpenDelete(false);
    }
  }, [getDeleteCheckState]);
  const resetData = () => {
    setOpenCancel(true);
  };
  // On Click of Cancel button
  const handelCancel = () => {
    const getValues = JSON.parse(
      window.localStorage.getItem('checkSearchValues')
    );
    setValues({
      ...values,
      checkLogNum: getValues.checkLogNum,
      checkNum: getValues.checkNum,
      batchNum: getValues.batchNum,
      checkIssuer: getValues.checkIssuer,
      informationTxt: getValues.checkInfo == null ? '' : getValues.checkInfo,
      checkAmt: getValues.checkAmt,
      totalAmt: getValues.totAllocatedAmt,
      invoiceReconcilication: getValues.invRecFormatCd,
      checkPayee: getValues.checkPayeeCd,
      disputeResolution: getValues.disputeResolutionCd,
      paymentType: getValues.paymentMediaTypeCd,
      batchDate: getValues.batchDt,
      checkDate: getValues.checkDt,
      postDate: getValues.postmarkedDt,
      receivedDate: getValues.receivedDt,
      suspendedDate: getValues.suspendedDt,
      corrLinkId: getValues.corrLinkId,
      fullyAllocated: getValues.allocationCompleteInd,
      usedDrugRebate: getValues.notDrugRebateInd,
      cnnNum:
        getValues.checkIdentifier == null ? '' : getValues.checkIdentifier,
      alterCheckAmt: '',
    });
    setOpenCancel(false);
    setErrorMessages([]);
    setFormsError({
      checkDate: false,
      receivedDate: false,
      suspendedDate: false,
      batchDate: false,
      postDate: false,
      alterCheckAmt: false,
    });
    setHasChanges(false);
  };
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: [
        'DISPUTE_RESOLUTION_CD',
        'CHECK_PAYEE_CD',
        'COLLECTION_MEDIUM_CD',
        'PAYMENT_MEDIA_TYPE_CD',
        'INV_REC_FORMAT_CD',
        'LAST_UPDATE_USER_ID ',
      ],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  React.useEffect(() => {
    setSuccessMessage([]);
    const getValues = JSON.parse(
      window.localStorage.getItem('checkSearchValues')
    );
    getSaveCheckState = {};
    setCorrLinkId(getValues.corrLinkId);
    const checkLogByCCN = JSON.parse(
      window.localStorage.getItem('checkLogByCCN')
    );
    const checkLogBatchNum = JSON.parse(
      window.localStorage.getItem('checkLogBatchNum')
    );
    if (checkLogByCCN) {
      setDisableCCN(false);
    } else if (checkLogByCCN == false || checkLogByCCN == null) {
      setDisableCCN(true);
    }
    if (checkLogBatchNum) {
      setDisableBatch(false);
    } else if (checkLogBatchNum == false || checkLogBatchNum == null) {
      setDisableBatch(true);
    }
    const dollarSymbol = '$';
    setValues({
      ...values,
      checkLogNum: maintainCheckRequest.checkLogNum || getValues.checkLogNum,
      checkNum: maintainCheckRequest.checkNum || getValues.checkNum,
      batchNum: maintainCheckRequest.batchNum || getValues.batchNum,
      checkIssuer: maintainCheckRequest.checkIssuer
        ? maintainCheckRequest.checkIssuer
        : maintainCheckRequest.checkIssuer == ''
        ? ''
        : getValues.checkIssuer,
      informationTxt:
        maintainCheckRequest.informationTxt || getValues.checkInfo,
      checkAmt: maintainCheckRequest.checkAmt || getValues.checkAmt,
      totalAmt: maintainCheckRequest.totalAmt || getValues.totAllocatedAmt,
      invoiceReconcilication:
        maintainCheckRequest.invoiceReconcilication || getValues.invRecFormatCd,
      checkPayee: maintainCheckRequest.checkPayee || getValues.checkPayeeCd,
      disputeResolution:
        maintainCheckRequest.disputeResolution || getValues.disputeResolutionCd,
      paymentType:
        maintainCheckRequest.paymentType || getValues.paymentMediaTypeCd,
      batchDate: maintainCheckRequest.batchDate || getValues.batchDt,
      checkDate: maintainCheckRequest.checkDate
        ? maintainCheckRequest.checkDate
        : maintainCheckRequest.checkDate === ''
        ? ''
        : getValues.checkDt,
      postDate: maintainCheckRequest.postDate || getValues.postmarkedDt,
      receivedDate: maintainCheckRequest.receivedDate || getValues.receivedDt,
      suspendedDate:
        maintainCheckRequest.suspendedDate || getValues.suspendedDt,
      corrLinkId: maintainCheckRequest.corrLinkId || getValues.corrLinkId,
      fullyAllocated:
        maintainCheckRequest.fullyAllocated || getValues.allocationCompleteInd,
      usedDrugRebate:
        maintainCheckRequest.usedDrugRebate || getValues.notDrugRebateInd,
      cnnNum: maintainCheckRequest.cnnNum || getValues.checkIdentifier,
    });
    // if (maintainCheckRequest && Object.keys(maintainCheckRequest).length > 0) {
    //   setHasChanges(true);
    // }
    setFormsError({
      ...formErrors,
      checkDate: maintainCheckFormErrorRequest.checkDate,
      receivedDate: maintainCheckFormErrorRequest.receivedDate,
      suspendedDate: maintainCheckFormErrorRequest.suspendedDate,
      batchDate: maintainCheckFormErrorRequest.batchDate,
      postDate: maintainCheckFormErrorRequest.postDate,
      checkIssuer: maintainCheckFormErrorRequest.checkIssuer,
      checkPayee: maintainCheckFormErrorRequest.checkPayee,
      // checkEmptyDate: maintainCheckFormErrorRequest.checkEmptyDate,
    });
    if (
      maintainCheckErrorMsgRequest &&
      Object.keys(maintainCheckErrorMsgRequest).length > 0
    ) {
      setErrorMessages(maintainCheckErrorMsgRequest);
    }
  }, []);

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async () => {
    if (corrLinkId !== null) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: [corrLinkId],
      });

      if (result && result.data?.length > 0) {
        setComments(true);
      } else {
        setComments(false);
      }
    }
  };

  React.useEffect(() => {
    handleExistingCommentList(corrLinkId);
  }, [values.checkLogNum]);

  React.useEffect(() => {
    handleExistingCommentList(corrLinkId);
  }, [commentsList?.length > 0 && values.checkLogNum]);

  const getParsedAmount = (value) => {
    return parseFloat(
      removeDollarForNumberFiled(removeCommaForNumberFiled(value))
    );
  };

  const getAmountClass = (amount) => {
    return isNaN(amount)
      ? 'mui-custom-form'
      : `mui-custom-form ${amount < 0 ? 'frr-color-red' : ''}`;
  };

  const formatCurrency = (amount) => {
    if (isNaN(amount)) return '$ 0.00';
    const absValue = Math.abs(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return amount < 0 ? `($ ${absValue})` : `$ ${absValue}`;
  };
  const checkAmt = getParsedAmount(values?.checkAmt);
  const totalAmt = getParsedAmount(values?.totalAmt);

  return (
    <>
      <Dialog
        open={openCancel}
        onClose={handelCancelClose}
        data-testid="handelCancelClose"
        className="multiGroupDialog custom-dialog-box dialog-420 popup-content-top-margin"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Cancel </span>
                <span className="float-right" onClick={handelCancelClose}>
                  <i className="fa fa-times-circle" aria-hidden="true" />
                </span>
                <div className="clearfix" />
              </div>
              <div className="text-center px-2">
                <DialogContentText style={{ color: 'black' }}>
                  There are unsaved changes. Do you want to continue?
                </DialogContentText>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper my-2">
              <Button
                onClick={() => {
                  handelCancel();
                }}
                data-testid="handelCancel"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>

              <Button
                onClick={() => {
                  handelCancelClose();
                }}
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>

      <Dialog
        open={openFullyAllocatedConfirm}
        className="multiGroupDialog custom-dialog-box dialog-420 declare-check-dialog"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Declare Check Allocated </span>
                <span className="float-right">
                  <i
                    className="fa fa-times-circle"
                    aria-hidden="true"
                    onClick={handleCloseFullyAllocatedConfirm}
                    data-testid="fullyAllocatedConfirmClose"
                  />
                </span>
                <div className="clearfix" />
              </div>
              <div className="p-3 margin-from-top">
                {ErrorMessage.FULLY_ALLOCATED_CONFIRMATION}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper mb-2 pt-4">
              <Button
                onClick={handleConfirmFullyAllocated}
                data-testid="confirmFullyAllocatedYes"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>
              <Button
                onClick={handleCloseFullyAllocatedConfirm}
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>

      <Dialog
        open={open}
        className="multiGroupDialog custom-dialog-box dialog-420 declare-check-dialog"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Declare Check Allocated </span>
                <span className="float-right">
                  <i
                    className="fa fa-times-circle"
                    aria-hidden="true"
                    onClick={handleClose}
                    data-testid="declareHandleClose"
                  />
                </span>
                <div className="clearfix" />
              </div>
              <div className="p-3 margin-from-top">
                Total Allocated Amount does not equal the Check Amount. If you
                mark it allocated the check will be suspended. Mark allocated
                and suspended the check?
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper mb-2 pt-4">
              <Button
                onClick={() => {
                  updateSuspendedDate();
                }}
                data-testid="updateSuspendedDate"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>
              <Button
                onClick={() => {
                  handleClose();
                }}
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <Dialog
        open={alterDialog}
        className="multiGroupDialog custom-dialog-box dialog-420 alter-check-dialog"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Alter Check Amount </span>
                <span className="float-right">
                  <i
                    className="fa fa-times-circle"
                    aria-hidden="true"
                    data-testid="closeAlterDialog"
                    onClick={closeAlterDialog}
                  />
                </span>
                <div className="clearfix" />
              </div>
              <div className="custom-check">
                <div className="form-wrapper px-5">
                  <div className="mui-custom-form input-md field-xl">
                    <TextField
                      id="Alter Amount"
                      label="Check Amount"
                      data-testid="alterAmount"
                      className="mandate-fields"
                      fullWidth
                      placeholder=""
                      disabled={isFieldsDisabled}
                      inputProps={{ maxLength: 22, id: 'Alter Amount' }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                        readOnly: isFieldsDisabled,
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className="prefix-symbol"
                          >
                            $
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.alterCheckAmt}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'alterCheckAmt');
                      }}
                      helperText={
                        formErrors.alterCheckAmt
                          ? ErrorMessage.VALID_ALTER_AMOUNT
                          : null
                      }
                      error={
                        formErrors.alterCheckAmt
                          ? ErrorMessage.VALID_ALTER_AMOUNT
                          : null
                      }
                      onBlur={(e) => {
                        handleAlterAmtBlurEvent(e, 'alterCheckAmt');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper mb-2">
              <Button
                onClick={() => {
                  updateCheckAmt();
                }}
                data-testid="updateCheckAmt"
                className="btn btn-success btn-search mr-2"
                disabled={isFieldsDisabled}
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Ok
              </Button>

              <Button
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
                onClick={closeAlterDialog}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <Dialog
        open={saveDialog}
        className="multiGroupDialog custom-dialog-box dialog-420  popup-content-top-margin"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Save </span>
                <span
                  className="float-right"
                  role="button"
                  data-testid="handleSaveClose"
                  tabIndex={0}
                  onClick={handleSaveClose}
                  onKeyDown={(e) => {
                    if (
                      e.key === 'Enter' ||
                      e.key === ' ' ||
                      e.code === 'Space'
                    ) {
                      e.preventDefault();
                      handleSaveClose();
                    }
                  }}
                  aria-label="Close"
                >
                  <i className="fa fa-times-circle" aria-hidden="true" />
                </span>
                {/* <span>
                     <img
                       alt="Close"
                       //src={CancelIcon}
                       style={{ padding: "0px 5px", float: "right" }}
                       onClick={closeAlterDialog}
                     />
                   </span> */}
                <div className="clearfix" />
              </div>
              <div className="text-center px-2">
                <DialogContentText style={{ color: 'black' }}>
                  Are you sure you want to Save your changes? To revert changes,
                  click on Cancel
                </DialogContentText>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper my-2">
              <Button
                onClick={masterDataSave}
                data-testid="masterDataSave"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>

              <Button
                onClick={handleSaveClose}
                data-testid="handleSaveClose1"
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <Dialog
        open={openDelete}
        className="multiGroupDialog custom-dialog-box dialog-420 popup-content-top-margin"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Delete </span>
                <span
                  className="float-right"
                  role="button"
                  data-testid="handleDeleteClose"
                  tabIndex={0}
                  onClick={handleDeleteClose}
                  onKeyDown={(e) => {
                    if (
                      e.key === 'Enter' ||
                      e.key === ' ' ||
                      e.code === 'Space'
                    ) {
                      e.preventDefault();
                      handleDeleteClose();
                    }
                  }}
                  aria-label="Close"
                >
                  <i className="fa fa-times-circle" aria-hidden="true" />
                </span>
                <div className="clearfix" />
              </div>
              <div className="text-center">
                <DialogContentText style={{ color: 'black' }}>
                  Are you sure you want to Delete the selected record?
                </DialogContentText>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <div className="btn-wrapper my-2">
              <Button
                onClick={masterDelete}
                data-testid="masterDelete"
                className="btn btn-success btn-search mr-2"
              >
                <SVGComponent iconName="Icon_awesome-check-circle" />
                Yes
              </Button>

              <Button
                onClick={handleDeleteClose}
                className="btn btn-cancel btn-primary"
                color="primary"
                autoFocus
              >
                <SVGComponent iconName="Icon-cancel" />
                No
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <div
        className="tBillPanel tabs-container custom-check frr-check"
        data-testid="maintainCheckComponent"
      >
        <div className="" data-testid="testingMaintain1">
          <Spinner load={spinnerLoader} />
          <CustomSeparator parent1="Maintain" parent2="Maintain Check" />
          <DisplaySuccessMessages successMessages={successMessage} />
          <DisplayErrorMessages errorMessages={errorMessages} />
          <div className="btn-wrapper frr-check-top-btns">
            <div className="mt-2 hide-on-print">
              <div className="float-left mb-2 float-md-none float-lg-left float-xl-left mt-sm-3 mt-md-3 mt-lg-3 mt-xl-0">
                <Button
                  className="btn btn-success btn-assignment ml-0"
                  onClick={() => {
                    declareCheckAllocated();
                  }}
                  data-testid="declareCheckAllocated"
                  disabled={!canDeclareCheckAllocated || checkReadOnlyAccess}
                >
                  <SVGComponent iconName="Icon_material-assignment-turned-in" />
                  Declare Check Allocated
                </Button>
                {hasAccess && (
                  <Button
                    className="btn btn-success btn-edit"
                    onClick={() => {
                      onClickAlterCheckAmt();
                    }}
                    data-testid="onClickAlterCheckAmt"
                    disabled={disableOtherButtons || isFieldsDisabled}
                  >
                    <SVGComponent iconName="Icon_feather-edit-2" />
                    Alter Check Amount
                  </Button>
                )}
                {hasAccess && (
                  <Button
                    className="btn btn-success btn-del"
                    onClick={() => onDelete()}
                    data-testid="onDelete"
                    disabled={
                      checkReadOnlyAccess ||
                      disableOtherButtons ||
                      !applicableUser ||
                      (applicableUser &&
                        values?.totalAmt &&
                        parseFloat(
                          values?.totalAmt?.toString()?.replace('$', '').trim()
                        ) > 0)
                    }
                  >
                    <SVGComponent iconName="Icon-trash" />
                    Delete
                  </Button>
                )}
              </div>
              <div className="float-right mb-2  float-md-right float-lg-right float-xl-right mt-sm-3 mt-md-3 mt-lg-3 mt-xl-0">
                <div
                  className="icon-history-cont"
                  onClick={getShowViewHistoryPlan}
                  data-testid="getShowViewHistoryPlan"
                >
                  <SVGComponent iconName="Icon-view-history" />
                </div>
                {hasAccess && (
                  <Button
                    className="btn btn-success btn-save"
                    onClick={() => {
                      onSave(true);
                    }}
                    disabled={
                      checkReadOnlyAccess ||
                      (disableOtherButtons && !canNormalUserSave) ||
                      !hasChanges ||
                      (!isEnableByRole && !hasChanges && !canNormalUserSave)
                    }
                    data-testid="saveBTN"
                  >
                    <SVGComponent iconName="Icon-awesome-save" />
                    Save
                  </Button>
                )}
                {hasAccess && (
                  <Button
                    className="btn btn-cancel btn btn-primary"
                    onClick={() => {
                      resetData();
                    }}
                    disabled={
                      checkReadOnlyAccess ||
                      !hasChanges ||
                      (!isEnableByRole && !hasChanges)
                    }
                    data-testid="resetBTN"
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    Cancel
                  </Button>
                )}
              </div>
              <div className="clearfix" />
            </div>
            {/* <div className="float-right mt-2 hide-on-print">
               
             </div> */}
            <div className="clearfix" />
            <div className="form-wrapper" />
          </div>
          <div className="tab-body">
            <form autoComplete="off">
              <fieldset className="custom-fieldset">
                <legend>Check Log Number</legend>

                <div className="form-wrapper frr-textfields">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="check_log-number"
                      data-testid="checkLogNumber"
                      label="Check Log Number"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxlength: 38 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={values.checkLogNum}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkLogNum');
                      }}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="check_number"
                      label="Check Number"
                      data-testid="checkNumber"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxlength: 20 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={isFieldsDisabled}
                      value={values.checkNum}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkNum');
                      }}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Cnn"
                      label="CCN"
                      data-testid="ccn"
                      fullWidth
                      disabled={!!disableCCN || isFieldsDisabled}
                      placeholder=""
                      inputProps={{ maxlength: 40 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.cnnNum}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'cnnNum');
                      }}
                    />
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      id="checkPayee"
                      label="Check Payee"
                      className="mandate-fields"
                      data-testid="check_payee"
                      fullWidth
                      required
                      select
                      disabled={isFieldsDisabled}
                      placeholder=""
                      inputProps={{ maxlength: 11, id: 'checkPayee' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.checkPayee}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'checkPayee');
                      }}
                      helperText={
                        formErrors.checkPayee
                          ? ErrorMessage.CHECK_PAYEE_VALIDATION
                          : null
                      }
                      error={
                        formErrors.checkPayee
                          ? ErrorMessage.CHECK_PAYEE_VALIDATION
                          : null
                      }
                      onBlur={(e) => {
                        handleBlurEvent(e, 'checkPayee');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.CHECK_PAYEE_CD?.map((item, key) => {
                        return (
                          <MenuItem
                            key={key}
                            value={item.codeValueID.codeValue}
                            className="frr-logcheck-dropdown-item"
                          >
                            {item.codeValueID.codeValue} -{' '}
                            {item.shortDescription}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                  <div className={getAmountClass(checkAmt)}>
                    <TextField
                      id="checkAmt"
                      label="Check Amount"
                      data-testid="checkAmount"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={formatCurrency(checkAmt)}
                    />
                  </div>
                  <div className={getAmountClass(totalAmt)}>
                    <TextField
                      id="totalAmt"
                      label="Total Allocated Amount"
                      data-testid="checkAmount"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={formatCurrency(totalAmt)}
                    />
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      id="disputeResolution"
                      label="Dispute Resolution"
                      data-testid="disputeResolution"
                      fullWidth
                      select
                      placeholder=""
                      disabled={isFieldsDisabled}
                      inputProps={{ maxlength: 10, id: 'disputeResolution' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={values.disputeResolution}
                      onChange={(e) => {
                        handleOnChangeEvent(e, 'disputeResolution');
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.DISPUTE_RESOLUTION_CD?.map(
                        (item, key) => {
                          return (
                            <MenuItem
                              key={key}
                              value={item.codeValueID.codeValue}
                              className="frr-logcheck-dropdown-item"
                            >
                              {item.codeValueID.codeValue} -{' '}
                              {item.shortDescription}
                            </MenuItem>
                          );
                        }
                      )}
                    </TextField>
                  </div>
                  <div className="mui-custom-form field-lg">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-wrapper">
                          <div className="mui-custom-form">
                            <div className="sub-check mt-1">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    style={{ marginRight: '5px' }}
                                    color="primary"
                                  />
                                }
                                data-testid="NotDrugRebate"
                                label="Not for Drug Rebate"
                                checked={
                                  parseInt(values?.usedDrugRebate, [0, 1]) === 1
                                }
                                value={
                                  parseInt(values?.usedDrugRebate, [0, 1]) === 1
                                }
                                disabled={isFieldsDisabled}
                                onChange={(e) => {
                                  const newObj = { ...values };
                                  newObj.usedDrugRebate =
                                    values.usedDrugRebate === 1 ? 0 : 1;
                                  setValues(newObj);
                                  const data = {
                                    ...maintainCheckRequest,
                                    usedDrugRebate: newObj.usedDrugRebate,
                                  };
                                  dispatch(maintainCheckReqAction(data));
                                  setHasChanges(true);
                                }}
                              />
                            </div>
                          </div>
                          <div className="mui-custom-form">
                            <div className="sub-check mt-1">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    style={{ marginRight: '5px' }}
                                    color="primary"
                                  />
                                }
                                data-testid="fullyAllocated"
                                disabled
                                label="Fully Allocated"
                                checked={values.fullyAllocated === 1}
                                value={values.fullyAllocated}
                                onChange={(e) => {
                                  handleOnChangeEvent(e, 'fullyAllocated');
                                }}
                              />
                            </div>
                          </div>
                          {hasAccess && (
                            <div className="mui-custom-form">
                              <div className="comment-sec mt-1">
                                Comments{' '}
                                {comments ? (
                                  <img
                                    role="button"
                                    onClick={() => {
                                      getCommentsService(true);
                                    }}
                                    alt="comment button"
                                    src={CommentVisibleIcon}
                                    data-testid="commentsOn"
                                  />
                                ) : (
                                  <img
                                    role="button"
                                    onClick={() => {
                                      getCommentsService(true);
                                    }}
                                    alt="comment image"
                                    src={CommentIcon}
                                    data-testid="commentsOff"
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="tab-body">
            <form autoComplete="off">
              <div className="row">
                <div className="col-12 col-sm-8 col-md-8">
                  <fieldset
                    className="custom-fieldset"
                    style={{ paddingRight: '0px' }}
                  >
                    <legend className="same-font-family">Check Dates</legend>
                    <div>
                      <div className="form-wrapper form-wrapper-col-4">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form input-md">
                            <KeyboardDatePicker
                              data-test="start-date"
                              className="mandate-fields"
                              id="checkDate"
                              label="Check Date"
                              format="MM/dd/yyyy"
                              data-testid="checkDate"
                              inputProps={{ id: 'checkDate' }}
                              value={values.checkDate}
                              // required
                              minDate={MinDate}
                              maxDate={MaxDate}
                              disabled={isFieldsDisabled}
                              onChange={(e) => {
                                handleChangeDate(e, 'checkDate');
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'Check Date',
                                disabled: isFieldsDisabled,
                              }}
                              onKeyDown={async (e) => {
                                if (e.keyCode == 67) {
                                  // copy date
                                  await window.navigator?.clipboard.writeText(
                                    e?.target?.value
                                  );
                                }
                              }}
                              helperText={
                                formErrors.checkDate
                                  ? ErrorMessage.CHECK_INVALID_DATE
                                  : // : formErrors.checkEmptyDate
                                    // ? ErrorMessage.CHECK_DATE_VALIDATION
                                    null
                              }
                              error={
                                formErrors.checkDate
                                  ? ErrorMessage.CHECK_INVALID_DATE
                                  : // : formErrors.checkEmptyDate
                                    // ? ErrorMessage.CHECK_DATE_VALIDATION
                                    null
                              }
                              onBlur={(date) => {
                                handleBlurDate(date, 'checkDate');
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>

                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form input-md">
                            <KeyboardDatePicker
                              data-test="end-date"
                              className="mandate-fields"
                              id="endDate-picker-dialog"
                              label="Postmark Date"
                              data-testid="postDate"
                              format="MM/dd/yyyy"
                              value={values.postDate}
                              disabled={isFieldsDisabled}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              // maxDate={findOnDayGreterThanStartDate()}
                              onChange={(date) => {
                                handleChangeDate(date, 'postDate');
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                                disabled: isFieldsDisabled,
                              }}
                              onKeyDown={async (e) => {
                                if (e.keyCode == 67) {
                                  // copy date
                                  await window.navigator?.clipboard.writeText(
                                    e?.target?.value
                                  );
                                }
                              }}
                              helperText={
                                formErrors.postDate
                                  ? ErrorMessage.POST_INVALID_DATE
                                  : null
                              }
                              error={
                                formErrors.postDate
                                  ? ErrorMessage.POST_INVALID_DATE
                                  : null
                              }
                              onBlur={(date) => {
                                handleBlurDate(date, 'postDate');
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>

                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form input-md">
                            <KeyboardDatePicker
                              data-test="start-date"
                              className="mandate-fields"
                              // maxDate={findOnDayGreterThanStartDate()}
                              id="receivedDate"
                              label="Received Date"
                              data-testid="receivedDate"
                              format="MM/dd/yyyy"
                              inputProps={{ id: 'receivedDate' }}
                              value={values.receivedDate}
                              disabled={isFieldsDisabled}
                              onChange={(e) => {
                                handleChangeDate(e, 'receivedDate');
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'Received Date',
                                disabled: isFieldsDisabled,
                              }}
                              // placeholder="mm/dd/yyyy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onKeyDown={async (e) => {
                                if (e.keyCode == 67) {
                                  // copy date
                                  await window.navigator?.clipboard.writeText(
                                    e?.target?.value
                                  );
                                }
                              }}
                              helperText={
                                formErrors.receivedDate
                                  ? ErrorMessage.REC_INVALID_DATE
                                  : null
                              }
                              error={
                                formErrors.receivedDate
                                  ? ErrorMessage.REC_INVALID_DATE
                                  : null
                              }
                              onBlur={(date) => {
                                handleBlurDate(date, 'receivedDate');
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>

                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div className="mui-custom-form input-md">
                            <KeyboardDatePicker
                              data-test="start-date"
                              className="mandate-fields"
                              // maxDate={findOnDayGreterThanStartDate()}
                              id="suspendedDate"
                              label="Suspended Date"
                              data-testid="suspendedDate"
                              disabled
                              format="MM/dd/yyyy"
                              inputProps={{ id: 'suspendedDate' }}
                              value={values.suspendedDate}
                              onChange={(e) => {
                                handleChangeDate(e, 'suspendedDate');
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onKeyDown={async (e) => {
                                if (e.keyCode == 67) {
                                  // copy date
                                  await window.navigator?.clipboard.writeText(
                                    e?.target?.value
                                  );
                                }
                              }}
                              helperText={
                                formErrors.suspendedDate
                                  ? ErrorMessage.SUS_INVALID_DATE
                                  : null
                              }
                              error={
                                formErrors.suspendedDate
                                  ? ErrorMessage.SUS_INVALID_DATE
                                  : null
                              }
                              onBlur={(date) => {
                                handleBlurDate(date, 'suspendedDate');
                              }}
                            />
                          </div>
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-12 col-sm-4 col-md-4 frr-batch-info">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Batch Information
                    </legend>
                    <div className="form-wrapper form-wrapper-col-4">
                      <div className="mui-custom-form input-md field-md">
                        <TextField
                          id="batchNo"
                          label="Batch Number"
                          fullWidth
                          data-testid="batchNum"
                          placeholder=""
                          inputProps={{ id: 'batchNo' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={isFieldsDisabled || check}
                          value={values.batchNum}
                          onChange={(e) => {
                            handleOnChangeEvent(e, 'batchNum');
                          }}
                        />
                      </div>

                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <div className="mui-custom-form input-md field-md">
                          <KeyboardDatePicker
                            data-test="start-date"
                            // maxDate={findOnDayGreterThanStartDate()}
                            id="batchDate"
                            className="mandate-fields"
                            label="Batch Date"
                            format="MM/dd/yyyy"
                            data-testid="batchDate"
                            inputProps={{ id: 'batchDate' }}
                            disabled={isFieldsDisabled}
                            value={values.batchDate}
                            onChange={(e) => {
                              handleChangeDate(e, 'batchDate');
                            }}
                            // placeholder="mm/dd/yyyy"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'Batch Date',
                              disabled: isFieldsDisabled,
                            }}
                            onKeyDown={async (e) => {
                              if (e.keyCode == 67) {
                                // copy date
                                await window.navigator?.clipboard.writeText(
                                  e?.target?.value
                                );
                              }
                            }}
                            helperText={
                              formErrors.batchDate
                                ? ErrorMessage.BATCH_INVALID_DATE
                                : null
                            }
                            error={
                              formErrors.batchDate
                                ? ErrorMessage.BATCH_INVALID_DATE
                                : null
                            }
                            onBlur={(date) => {
                              handleBlurDate(date, 'batchDate');
                            }}
                          />
                        </div>
                      </MuiPickersUtilsProvider>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
          <div className="tab-body">
            <form autoComplete="off">
              <div className="tab-holderes">
                <fieldset className="custom-fieldset">
                  <legend>Payment Type</legend>
                  <div className="form-wrapper form-wrapper-col-4">
                    <div className="mui-custom-form with-select">
                      <TextField
                        id="payment_type"
                        label="Payment Type"
                        fullWidth
                        select
                        data-testid="paymentType"
                        placeholder=""
                        inputProps={{ maxlength: 10, id: 'payment_type' }}
                        disabled={isFieldsDisabled}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.paymentType}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'paymentType');
                        }}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {commonDropdownList?.PAYMENT_MEDIA_TYPE_CD?.map(
                          (item, key) => {
                            return (
                              <MenuItem
                                key={key}
                                value={item.codeValueID.codeValue}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.codeValueID.codeValue} -{' '}
                                {item.shortDescription}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="checkIssuer"
                        label="Check Issuer"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        required
                        data-testid="checkIssuer"
                        disabled={isFieldsDisabled}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 255,
                          id: 'checkIssuer',
                        }}
                        value={values.checkIssuer}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'checkIssuer');
                        }}
                        helperText={
                          formErrors.checkIssuer
                            ? ErrorMessage.CHECK_ISSUER_VALIDATION
                            : null
                        }
                        error={
                          formErrors.checkIssuer
                            ? ErrorMessage.CHECK_ISSUER_VALIDATION
                            : null
                        }
                        onBlur={(e) => {
                          handleBlurEvent(e, 'checkIssuer');
                        }}
                      />
                    </div>
                    <div className="mui-custom-form with-select">
                      <TextField
                        id="Invoice_Reconciliation_Format"
                        label="Invoice Reconciliation Format"
                        fullWidth
                        select
                        placeholder=""
                        data-testid="invoiceReconcilication"
                        disabled={isFieldsDisabled}
                        inputProps={{
                          maxlength: 10,
                          id: 'Invoice_Reconciliation_Format',
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={values.invoiceReconcilication}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'invoiceReconcilication');
                        }}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {commonDropdownList?.INV_REC_FORMAT_CD?.map(
                          (item, key) => {
                            return (
                              <MenuItem
                                key={key}
                                value={item.codeValueID.codeValue}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.codeValueID.codeValue} -{' '}
                                {item.shortDescription}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>
                    </div>
                    <div className="mui-custom-form input-md">
                      <TextField
                        id="checkInfo"
                        label="Check Information"
                        fullWidth
                        placeholder=""
                        value={values.informationTxt}
                        disabled={isFieldsDisabled}
                        data-testid="informationTxt"
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'informationTxt');
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxLength: 2000,
                          id: 'checkInfo',
                        }}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CHECK_LOG"
          keyValue={keyValue}
          isSpinner
        />
      ) : null}
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CHECK_LOG"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={values.checkLogNum.toString()}
          checkReadOnlyAccess={checkReadOnlyAccess}
        />
      ) : null}
    </>
  );
};

export default withRouter(MaintainCheck);
